import React, { useState } from 'react';
import { 
  UserPlus, UserCheck, ShieldAlert, Star, 
  Trash2, Edit3, Search, Heart, ArrowLeft, Save, Users
} from 'lucide-react';

// ✅ CONEXIÓN AL SISTEMA NERVIOSO CENTRAL (Ruta Absoluta)
import { useGlobal } from 'context/GlobalContext';

const GestionAyudantes = () => {
  // 1. Conexión global para persistencia de datos del staff voluntario
  const { ayudantesGlobal, setAyudantesGlobal } = useGlobal();

  const [vista, setVista] = useState('lista'); 
  const [ayudanteEditando, setAyudanteEditando] = useState(null);
  const [busqueda, setBusqueda] = useState('');

  const [formData, setFormData] = useState({
    nombre: '', tel: '', paciente: false, primerosAuxilios: false, experiencia: '', observacionSeguridad: ''
  });

  const handleNuevo = () => {
    setAyudanteEditando(null);
    setFormData({ nombre: '', tel: '', paciente: false, primerosAuxilios: false, experiencia: '', observacionSeguridad: '' });
    setVista('formulario');
  };

  const handleEditar = (ayudante) => {
    setAyudanteEditando(ayudante);
    setFormData({ 
      ...ayudante, 
      paciente: ayudante.aptitudes?.paciente || false, 
      primerosAuxilios: ayudante.aptitudes?.primerosAuxilios || false,
      experiencia: ayudante.aptitudes?.experiencia || '',
      observacionSeguridad: ayudante.aptitudes?.observacionSeguridad || ''
    });
    setVista('formulario');
  };

  const eliminarAyudante = (id) => {
    if(window.confirm("¿REMOVER VOLUNTARIO? Esta acción revocará sus permisos de acceso a las áreas infantiles de forma inmediata.")) {
      setAyudantesGlobal(prev => prev.filter(a => a.id !== id));
    }
  };

  const guardarAyudante = (e) => {
    e.preventDefault();
    const nuevoRegistro = {
      id: ayudanteEditando ? ayudanteEditando.id : Date.now(),
      nombre: formData.nombre.toUpperCase(),
      tel: formData.tel,
      estatus: 'Activo',
      aptitudes: {
        paciente: formData.paciente,
        primerosAuxilios: formData.primerosAuxilios,
        experiencia: formData.experiencia,
        observacionSeguridad: formData.observacionSeguridad
      }
    };

    if (ayudanteEditando) {
      setAyudantesGlobal(prev => prev.map(a => a.id === ayudanteEditando.id ? nuevoRegistro : a));
    } else {
      setAyudantesGlobal(prev => [...prev, nuevoRegistro]);
    }
    setVista('lista');
    alert("✅ Staff Sincronizado con el Módulo Maestro.");
  };

  const filtrados = (ayudantesGlobal || []).filter(a => 
    a.nombre?.toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div className="w-full space-y-8 animate-in fade-in duration-500 text-left font-sans pb-10">
      
      {vista === 'lista' ? (
        <>
          {/* HEADER DE GESTIÓN */}
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 border-b-4 border-slate-100 pb-8">
            <div className="space-y-2">
              <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-600 px-4 py-2 rounded-full border border-emerald-100 shadow-sm">
                <UserCheck size={16} />
                <span className="text-[10px] font-black uppercase tracking-widest italic">Base de Voluntariado</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-black text-slate-900 italic tracking-tighter leading-none uppercase">Staff / Ayudantes</h2>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4">
              <div className="relative w-full sm:w-72 group">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-indigo-500 transition-colors" size={18} />
                <input 
                  type="text" placeholder="Buscar voluntario..." 
                  className="w-full pl-12 pr-4 py-4 bg-white rounded-2xl border-2 border-slate-50 shadow-inner outline-none focus:border-indigo-500 font-bold text-slate-700"
                  value={busqueda} onChange={e => setBusqueda(e.target.value)}
                />
              </div>
              <button 
                onClick={handleNuevo}
                className="w-full sm:w-auto bg-[#0A2440] text-white px-8 py-5 rounded-[2rem] flex items-center justify-center gap-3 shadow-xl hover:bg-emerald-600 transition-all active:scale-95 border-b-8 border-slate-800"
              >
                <UserPlus size={22} className="text-emerald-400" />
                <span className="font-black text-xs uppercase tracking-widest">Registrar Staff</span>
              </button>
            </div>
          </div>

          {/* GRID DE STAFF ACTIVO */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filtrados.length === 0 ? (
              <div className="col-span-full py-24 text-center bg-slate-100 rounded-[4rem] border-4 border-dashed border-slate-200 opacity-40">
                <Users size={60} className="mx-auto mb-4 text-slate-400" strokeWidth={1} />
                <p className="font-black uppercase tracking-widest text-slate-500 italic">No hay staff registrado en el radar</p>
              </div>
            ) : (
              filtrados.map(ayudante => (
                <div key={ayudante.id} className="bg-white p-8 rounded-[3.5rem] shadow-sm border-2 border-slate-50 flex flex-col items-center text-center space-y-6 hover:shadow-2xl hover:border-indigo-100 transition-all group relative">
                  
                  <button onClick={() => eliminarAyudante(ayudante.id)} className="absolute top-6 right-6 p-2 text-slate-200 hover:text-rose-500 transition-colors">
                    <Trash2 size={18} />
                  </button>

                  <div className="w-24 h-24 rounded-[2.5rem] bg-slate-50 flex items-center justify-center text-slate-300 group-hover:bg-indigo-50 group-hover:text-indigo-500 transition-all shadow-inner">
                    <Users size={40} />
                  </div>
                  
                  <div>
                    <h3 className="text-2xl font-black text-slate-800 leading-none italic uppercase tracking-tighter">{ayudante.nombre}</h3>
                    <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-3 italic">{ayudante.tel}</p>
                  </div>

                  <div className="flex gap-3">
                    {ayudante.aptitudes?.primerosAuxilios && (
                      <div className="p-3 bg-rose-50 text-rose-500 rounded-2xl border border-rose-100 shadow-sm" title="Primeros Auxilios">
                        <ShieldAlert size={20}/>
                      </div>
                    )}
                    {ayudante.aptitudes?.paciente && (
                      <div className="p-3 bg-emerald-50 text-emerald-500 rounded-2xl border border-emerald-100 shadow-sm" title="Experto Niños">
                        <Heart size={20} fill="currentColor" />
                      </div>
                    )}
                  </div>

                  <button 
                    onClick={() => handleEditar(ayudante)} 
                    className="w-full py-4 rounded-2xl bg-slate-900 text-white font-black text-[10px] uppercase tracking-[0.2em] hover:bg-indigo-600 transition-all shadow-xl active:scale-95"
                  >
                    Ver Expediente
                  </button>
                </div>
              ))
            )}
          </div>
        </>
      ) : (
        /* FORMULARIO DE ALTA / EDICIÓN */
        <div className="max-w-4xl mx-auto space-y-6">
          <button onClick={() => setVista('lista')} className="flex items-center gap-2 text-slate-400 font-black text-[10px] uppercase tracking-widest hover:text-rose-500 transition-colors ml-4 italic">
            <ArrowLeft size={16} /> Cancelar Registro
          </button>

          <form onSubmit={guardarAyudante} className="bg-white rounded-[4.5rem] shadow-2xl border-4 border-slate-50 overflow-hidden">
            <div className="bg-[#0A2440] p-10 md:p-14 text-white text-center relative overflow-hidden">
              <div className="absolute top-0 right-0 w-40 h-40 bg-indigo-500/10 rounded-full -mr-20 -mt-20 blur-3xl" />
              <span className="text-[10px] font-black text-amber-500 uppercase tracking-[0.4em] italic mb-3 block">Staff Credentials</span>
              <h3 className="text-4xl font-black italic tracking-tighter uppercase leading-none">
                {ayudanteEditando ? 'Actualizar Miembro' : 'Alta de Voluntario'}
              </h3>
            </div>
            
            <div className="p-10 md:p-16 space-y-12">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                
                {/* IDENTIDAD */}
                <div className="space-y-6 text-left">
                  <h4 className="text-[10px] font-black uppercase text-indigo-500 tracking-widest ml-6 italic">Información Crítica</h4>
                  <input 
                    type="text" placeholder="NOMBRE COMPLETO" required
                    value={formData.nombre} onChange={e => setFormData({...formData, nombre: e.target.value.toUpperCase()})}
                    className="w-full p-6 bg-slate-50 rounded-[2.2rem] border-2 border-transparent focus:border-indigo-500 font-black text-xl outline-none shadow-inner uppercase"
                  />
                  <input 
                    type="tel" placeholder="NÚMERO WHATSAPP" required
                    value={formData.tel} onChange={e => setFormData({...formData, tel: e.target.value})}
                    className="w-full p-6 bg-slate-50 rounded-[2.2rem] border-2 border-transparent focus:border-indigo-500 font-black text-xl outline-none shadow-inner"
                  />
                </div>

                {/* APTITUDES */}
                <div className="space-y-6 text-left">
                  <h4 className="text-[10px] font-black uppercase text-indigo-500 tracking-widest ml-6 italic">Filtros de Aptitud</h4>
                  <div className="grid grid-cols-1 gap-4">
                    <button 
                      type="button" onClick={() => setFormData({...formData, paciente: !formData.paciente})}
                      className={`p-6 rounded-[2rem] border-4 flex items-center justify-between transition-all ${formData.paciente ? 'border-emerald-500 bg-emerald-50 text-emerald-700 shadow-md' : 'border-slate-50 bg-slate-50 text-slate-300'}`}
                    >
                      <span className="text-xs font-black uppercase tracking-widest italic">Paciencia / Cuidados</span>
                      <Heart size={24} fill={formData.paciente ? "currentColor" : "none"} />
                    </button>
                    <button 
                      type="button" onClick={() => setFormData({...formData, primerosAuxilios: !formData.primerosAuxilios})}
                      className={`p-6 rounded-[2rem] border-4 flex items-center justify-between transition-all ${formData.primerosAuxilios ? 'border-rose-500 bg-rose-50 text-rose-700 shadow-md' : 'border-slate-50 bg-slate-50 text-slate-300'}`}
                    >
                      <span className="text-xs font-black uppercase tracking-widest italic">Primeros Auxilios</span>
                      <ShieldAlert size={24} />
                    </button>
                  </div>
                </div>
              </div>

              {/* OBSERVACIONES */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-4 text-left">
                <div className="space-y-3">
                  <h4 className="text-[10px] font-black uppercase text-slate-400 tracking-widest ml-6 italic">Experiencia Operativa</h4>
                  <textarea 
                    placeholder="Servicios anteriores, grupos trabajados..."
                    value={formData.experiencia} onChange={e => setFormData({...formData, experiencia: e.target.value})}
                    className="w-full p-8 bg-slate-50 rounded-[3rem] border-none text-sm font-bold text-slate-700 h-44 resize-none outline-none focus:ring-4 focus:ring-indigo-500/5 shadow-inner italic"
                  />
                </div>
                <div className="space-y-3">
                  <h4 className="text-[10px] font-black uppercase text-amber-600 tracking-widest ml-6 italic">Ficha Interna (Admin)</h4>
                  <div className="bg-amber-50 p-8 rounded-[3rem] border-2 border-amber-100 shadow-inner h-44">
                    <textarea 
                      placeholder="Comentarios privados del Líder o Pastor sobre este voluntario..."
                      value={formData.observacionSeguridad} onChange={e => setFormData({...formData, observacionSeguridad: e.target.value})}
                      className="w-full bg-transparent border-none text-sm font-bold text-amber-900 outline-none resize-none h-full italic"
                    />
                  </div>
                </div>
              </div>

              <button 
                type="submit"
                className="w-full bg-slate-900 text-white py-8 rounded-[3.5rem] font-black text-sm uppercase tracking-[0.3em] shadow-2xl hover:bg-indigo-600 active:scale-95 transition-all flex items-center justify-center gap-4 border-b-8 border-slate-700"
              >
                <Save size={24} className="text-emerald-400" /> {ayudanteEditando ? 'Guardar Cambios' : 'Confirmar Alta de Staff'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default GestionAyudantes;